<template>
  <div class="eatHealthyIndex">
    <keep-alive :include='includes' :max="5">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped>
.eatHealthyIndex {
  height: 100%;
  background: @expertBorderColor242;
}
</style>


<script>
import { mapState } from 'vuex'

export default {
  name: "eatHealthyIndex",
  components: {},
  data() {
    return {};
  },
  computed: {// 在computed中动态监控
    ...mapState({
      includes: state => state.includes,
    }),
  },
  mounted() {
  },
  created() { },
  methods: {

  }
};
</script>
